import React, {Fragment} from 'react';
import createForm from "./Form";
import {CurrencyFormatter, PartnerSelect} from "../../../utils/formatters";
import ComponentConfig from "../../form/ComponentConfig";
import isEqual from "lodash-es/isEqual";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import {ifCompletedInput} from "../../../utils/other";
import {postData} from "../../../utils/request";
import classNames from 'classnames';
import Icon from "../../form/Icon";
import DetailsButton from "../../form/DetailsButton";
import Button from "../../form/Button";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import ComponentField from "../../form/ComponentField";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {Button as PrimeButton} from 'primereact/components/picklist/../button/Button';
import TransactionPaymentEditor from "../TransactionPaymentEditor";
import ModalEditor from "../ModalEditor";
import None from "../None";

const percentColors = [
    {pct: 0.0, color: {r: 13, g: 219, b: 13}},
    {pct: 1.0, color: {r: 255, g: 0, b: 0}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

class RoundingCorrectionButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            opened: false,
            amount: this.props.transaction.balance
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.transaction.balance, prevProps.transaction.balance)) {
            this.setState({
                amount: this.props.transaction.balance
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        header="Kerekítéses kompenzáció"
                        size="small"
                        state={this.state.opened}
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: "Kompenzálás",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClick: async () => {
                                    try {
                                        this.setState({isLoading: true});
                                        await postData({
                                            action: 'RoundingCorrection.create',
                                            data: {
                                                transaction: this.props.transaction.id,
                                            }
                                        });
                                        this.props.callBack && this.props.callBack();
                                        this.setState({opened: false, isLoading: false});
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }
                            }
                        ]}
                    >
                        <b>Biztos? {CurrencyFormatter(this.state.amount).props.children} kerekítés lesz hozzáadva!</b>
                    </Modal>
                </Portal>
                <Button
                    disabled={this.state.amount == 0}
                    icon={{lib: "fas", name: "receipt"}}
                    size="xs"
                    color="default"
                    tooltip="Kerekítéses kompenzáció"
                    block={true}
                    onClick={(e) => {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                        this.setState({opened: true});
                        return false;
                    }}
                />
            </Fragment>
        );
    }
}

const sortable = true;
const filterable = true;

class FieldEditor extends React.Component {

    render() {
        return (
            <Fragment>
                <Button
                    color="default"
                    size="xs"
                    onClick={() => this.editor && this.editor.focus()}
                    tooltip="Kiegyenlítések"
                    icon={{name: "money-check-alt", lib: "fas"}}
                />
                <ModalEditor ref={(editor) => this.editor = editor} {...this.props} />
            </Fragment>
        );
    }
}

class TransactionPaymentModalList extends React.Component {

    render() {
        return (
            <Fragment>
                <TransactionPaymentEditor
                    loader={null}
                    presets={{transaction: this.props.transactionId}}
                    editor={None}
                    list={FieldEditor}
                    listFilter={[{
                        field: "transaction",
                        value: this.props.transactionId
                    }]}
                />
            </Fragment>
        );
    }
}

class TargetList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    render() {
        return (
            <div>
                <SelectorGrid
                    ref={(list) => this.list = list}
                    component={this.props.componentConfig.componentname}
                    data={this.props.values}
                    listfield="TransactionPayments"
                    pageSize={15}
                    view={["invoice.invoice_id","transaction.balance","transaction.id","transaction.relativeamount","transaction.total","transaction.paid","transaction.amount","transaction.client_component","transaction.client_component_id"]}
                    rowClassName={(rowData) => {
                        return {"danger color": parseFloat(rowData.transaction.amount || "0") + "" !== "" + parseFloat(rowData.transaction.paid || "0"), "success color": parseFloat(rowData.transaction.amount || "0") + "" === "" + parseFloat(rowData.transaction.paid || "0")};
                    }}
                    aggregations={{
                        fields: {
                            "transaction.relativeamount": {
                                field: "transaction.relativeamount", type: "SUM"
                            },
                            /*"transaction.amount": {
                                field: "transaction.amount", type: "SUM"
                            },*/
                            "transaction.balance": {
                                field: "transaction.balance", type: "SUM"
                            },
                        }
                    }}
                    filter={this.props.filter}
                    selectionMode={this.props.selectionMode}
                    selection={this.props.selection}
                    onSelectionChange={this.props.onSelectionChange}
                    columns={{
                        "client_component": {
                            header: ' ',
                            width: 'cell-button',
                            renderer: (value, rowData) => {
                                return <div className="nowrap">
                                    <DetailsButton
                                        loader={null}
                                        icon={true}
                                        block={false}
                                        component_type={rowData.transaction.client_component}
                                        component_id={rowData.transaction.client_component_id}
                                    />
                                    <DetailsButton
                                        loader={null}
                                        icon={{name: "file-invoice", lib: "fas"}}
                                        block={false}
                                        component_type="invoice"
                                        component_id={rowData.invoice.invoice_id}
                                    />
                                    <TransactionPaymentModalList transactionId={rowData.transaction.id} />
                                </div>;
                            }
                        },
                        "invoice.billnum": {
                            header: 'Sorszám',
                            width: 2,
                            className: "nowrap",
                            sortable,
                            filterable,
                            renderer: (value, rowData) => {
                                const roundAmount = Math.round(rowData.transaction.amount);
                                const roundBalance = Math.round(rowData.transaction.balance);
                                const percent = (Math.abs(roundBalance) / roundAmount).toFixed(2);
                                return <Fragment>{parseFloat(rowData.transaction.balance) !== 0 ? <Icon style={{color: getColorForPercentage(percent)}} className="pull-right" lib="fas" name={parseInt(rowData.transaction.balance) < 0 ? "money-bill-wave" : "money-bill"} tooltip={<Fragment>Teljes összeg: {CurrencyFormatter(rowData.transaction.amount).props.children} <br/>Kiegyenlítetetlen összeg: {CurrencyFormatter(rowData.transaction.balance).props.children}</Fragment>}/> : null} {value}</Fragment>;
                            }
                        },
                        "invoice.deadline": {
                            header: 'Határidő',
                            width: 1,
                            className: "nowrap",
                            sortable,
                            filterable
                        },
                        "invoice.partner.name": {
                            header: 'Partner',
                            width: 7,
                            sortable,
                            filterable
                        },
                        "invoice.totalprice": {
                            header: 'Számla végösszeg',
                            width: 1,
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "nowrap currency"
                        },
                        "transaction.relativeamount": {
                            header: "Tranzakció összege",
                            width: 1,
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "nowrap currency"
                        },
                        "transaction.balance": {
                            header: "Kiegyenlítetlen összeg",
                            width: 1,
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "nowrap currency"
                        },
                        "total": {
                            header: "Összeg",
                            width: 1,
                            sortable,
                            filterable,
                            renderer: CurrencyFormatter,
                            className: "nowrap currency"/*
                            renderer: (value) => CurrencyFormatter(parseInt(this.props.values.state || "0") === 0 ? 0 : value),
                            className: "nowrap currency",
                            tooltip: () => parseInt(this.props.values.state || "0") === 0 ? "Az összeget a rendszer fogja kitölteni a lezárás után!" : null*/
                        },
                        "client_component_id": {
                            header: ' ',
                            width: 'cell-button',
                            renderer: (value, rowData) => {
                                return <Fragment>
                                    <RoundingCorrectionButton
                                        callBack={() => {
                                            this.refresh();
                                            this.props.reloadAmount && this.props.reloadAmount();
                                        }}
                                        transaction={rowData.transaction}
                                        value={value}
                                        rowData={rowData}
                                    />
                                </Fragment>;
                            }
                        },
                    }}
                />
            </div>
        );
    }
}

class CompensationForm extends React.Component {

    state = {
        idFilter: [],
        filtered: false,
        parameters: {},
        poolSelection: [],
        toSelection: [],
        fromSelection: [],
        separated: false
    };

    convert = (row) => {
        row.qty = row.amount || 0;
        return row;
    }

    moveItems = async () => {
        if (this.state.poolSelection.length || this.state.fromSelection.length || this.state.toSelection.length) {
            let items = [];
            let actionparams = {
                parentcomponent: this.props.componentConfig.componentname,
                listfield: "TransactionPayments",
                parentid: this.props.values[this.props.componentConfig.idfield]
            };
            if (this.state.poolSelection.length) {
                items = this.state.poolSelection.map((_item) => {
                    const item = {};
                    item.transaction = _item.id;
                    item.payment_component = this.props.componentConfig.componentname;
                    item.payment_component_id = this.props.values[this.props.componentConfig.idfield];
                    item.amount = 0;
                    return item;
                });
                actionparams = {
                    ...actionparams,
                    action: "componentlist.addItemsToList",
                    items: items.map((item) => ({data: item}))
                };
                await postData(actionparams);
            } else {
                actionparams = {
                    ...actionparams,
                    action: "componentlist.removeItemsFromList",
                    items: this.state.toSelection.length ? this.state.toSelection : this.state.fromSelection
                };
                await postData(actionparams);
            }
            this.setState({poolSelection: [], fromSelection: [], toSelection: []});
            this.refreshLists();
        }
    }

    refreshLists = () => {
        this.poolList && this.poolList.refresh();
        this.fromList && this.fromList.refresh();
        this.toList && this.toList.refresh();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values[this.props.componentConfig.idfield] + "" !== "" + prevProps.values[prevProps.componentConfig.idfield]) {
            this.setState({poolSelection: [], fromSelection: [], toSelection: []});
        }
    }

    render() {
        const sortable = true;
        const filterable = true;
        const invoiceFilter = [
            {filters: [{field: "invoice.from", value: this.props.till.pos.partner.partner_id},{field: "invoice.to", value: this.props.till.pos.partner.partner_id}], operator: "OR"},
            {field: "MoneyTransfer_id", value: this.props.values[this.props.componentConfig.idfield], operator: "!<=>"},
            {field: "balance", value: 0, operator: "!="},
            {field: "invoice.type", value: [666], operator: "not in"}
        ];
        if (this.props.values.partner && this.props.values.partner.partner_id) {
            invoiceFilter.push({field: "invoice.partner", value: this.props.values.partner.partner_id});
            /*invoiceFilter.push({
                filters: {
                    operator: "OR",
                    filters: [
                        {
                            field: "invoice.from", value: this.props.values.partner.partner_id
                        },
                        {
                            field: "invoice.to", value: this.props.values.partner.partner_id
                        }
                    ]
                }
            });*/
        }
        if (this.state.idFilter.length) {
            invoiceFilter.push({field: "invoice", value: this.state.idFilter, operator: "not in"});
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            label="Partner"
                            name="partner"
                            component="partner"
                            objectValue={true}
                            optionsTemplate={PartnerSelect}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            {...this.props.getFieldProps("partner")}
                            value={this.props.values.partner}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <DateTimeInput
                            name="transferdate"
                            label="Fizetés dátuma"
                            {...this.props.getFieldProps("transferdate")}
                            value={this.props.values.transferdate}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-md-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="document"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    isClearable={false}
                                    isUploadable={false}
                                    label="Dokumentum"
                                />
                            </div>
                            <div className="col-md-6">
                                <ComponentField
                                    getFieldProps={this.props.getFieldProps}
                                    componentConfig={this.props.componentConfig}
                                    name="document"
                                    values={this.props.values}
                                    setFieldValue={this.props.setFieldValue}
                                    label="Partner dokumentum"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && this.props.values.partner && <Fragment>
                    {this.props.values.state + "" === "0" && <Fragment>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="control-label">Számlák</label>
                                <div className="form-group">
                                    <SelectorGrid
                                        ref={(poolList) => this.poolList = poolList}
                                        component="businesstransaction"
                                        reqparams={{exact: true}}
                                        pageSize={5}
                                        view={["invoice.type","invoice.invoice_id","balance","total","paid","amount","client_component","client_component_id"]}
                                        filter={invoiceFilter}
                                        parameters={this.state.parameters}
                                        selectionMode="multiple"
                                        selection={(this.props.values.state || "0") + "" !== "0" ? [] : this.state.poolSelection}
                                        onSelectionChange={(e) => {
                                            if ((this.props.values.state || "0") + "" !== "0") return;
                                            this.setState({poolSelection: e.value, fromSelection: [], toSelection: []});
                                        }}
                                        rowClassName={(rowData) => {
                                            return {"danger color": parseFloat(rowData.amount || "0") + "" !== "" + parseFloat(rowData.paid || "0"), "success color": parseFloat(rowData.amount || "0") + "" === "" + parseFloat(rowData.paid || "0")};
                                        }}
                                        columns={{
                                            "client_component": {
                                                header: ' ',
                                                width: 'cell-button',
                                                renderer: (value, rowData) => {
                                                    return <div className="nowrap">
                                                        <DetailsButton
                                                            loader={null}
                                                            icon={true}
                                                            block={false}
                                                            component_type={rowData.client_component}
                                                            component_id={rowData.client_component_id}
                                                        />
                                                        <DetailsButton
                                                            loader={null}
                                                            icon={{name: "file-invoice", lib: "fas"}}
                                                            block={false}
                                                            component_type="invoice"
                                                            component_id={rowData.invoice.invoice_id}
                                                        />
                                                        <TransactionPaymentModalList transactionId={rowData.id} />
                                                    </div>;
                                                }
                                            },
                                            "invoice.billnum": {
                                                header: 'Sorszám',
                                                width: 2,
                                                className: "nowrap",
                                                sortable,
                                                filterable,
                                                onFilter: (field, value, operator, validate, column, matchmode) => {
                                                    this.setState({parameters: {...this.state.parameters, billnum: value}});
                                                },
                                                renderer: (value, rowData) => {
                                                    const roundAmount = Math.round(rowData.amount);
                                                    const roundBalance = Math.round(rowData.balance);
                                                    const percent = (Math.abs(roundBalance) / roundAmount).toFixed(2);
                                                    return <Fragment>{parseFloat(rowData.balance) !== 0 ? <Icon style={{color: getColorForPercentage(percent)}} className="pull-right" lib="fas" name={parseInt(rowData.balance) < 0 ? "money-bill-wave" : "money-bill"} tooltip={<Fragment>Teljes összeg: {CurrencyFormatter(rowData.amount).props.children} <br/>Kiegyenlítetetlen összeg: {CurrencyFormatter(rowData.balance).props.children}</Fragment>}/> : null} {value}</Fragment>;
                                                }
                                            },
                                            "invoice.deadline": {
                                                header: 'Határidő',
                                                width: 1,
                                                className: "nowrap",
                                                sortable,
                                                filterable
                                            },
                                            "invoice.partner.name": {
                                                header: 'Partner',
                                                width: 7,
                                                sortable,
                                                filterable
                                            },
                                            "invoice.totalprice": {
                                                header: 'Számla végösszeg',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "nowrap currency"
                                            },
                                            "relativeamount": {
                                                header: 'Tranzakció összege',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "nowrap currency"
                                            },
                                            "balance": {
                                                header: "Kiegyenlítetlen összeg",
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "nowrap currency"
                                            },
                                            "client_component_id": {
                                                header: ' ',
                                                width: 'cell-button',
                                                renderer: (value, rowData) => {
                                                    return <Fragment>
                                                        <RoundingCorrectionButton
                                                            callBack={() => {
                                                                this.refreshLists();
                                                                this.props.reloadAmount && this.props.reloadAmount();
                                                            }}
                                                            transaction={rowData}
                                                            value={value}
                                                            rowData={rowData}
                                                        />
                                                    </Fragment>;
                                                }
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row picklist">
                            <div className="col-md-12 picklist-control text-center">
                                <PrimeButton type="button" icon={classNames("pi pi-angle-down", {"disabled": this.props.disabled || !this.state.poolSelection.length || (this.props.values.state || "0") + "" !== "0" || false})} disabled={this.props.disabled || !this.state.poolSelection.length || (this.props.values.state || "0") + "" !== "0" || false} onClick={this.moveItems} />
                                <PrimeButton type="button" icon={classNames("pi pi-angle-up", {"disabled": this.props.disabled || !(this.state.toSelection.length || this.state.fromSelection.length) || (this.props.values.state || "0") + "" !== "0" || false})} disabled={this.props.disabled || !(this.state.toSelection.length || this.state.fromSelection.length) || (this.props.values.state || "0") + "" !== "0" || false} onClick={this.moveItems} />
                                {/*<PrimeButton type="button" icon={classNames("pi", {"pi-circle-on": !this.state.separated, "pi-ellipsis-h": this.state.separated})} onClick={() => {
                                    this.setState({separated: !this.state.separated});
                                }} />*/}
                            </div>
                        </div>
                    </Fragment>}
                    {this.props.values.state + "" !== "0" && <Fragment>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="control-label">Számlák</label>
                            </div>
                        </div>
                    </Fragment>}
                    <div className="row">
                        <div className={classNames({"col-md-6": this.state.separated, "col-md-12": !this.state.separated})}>
                            <div className="form-group">
                                <TargetList
                                    ref={(fromList) => this.fromList = fromList}
                                    {...this.props}
                                    filter={this.state.separated ? [{field: "invoice.from", value: this.props.values.partner.partner_id}] : []}
                                    selectionMode="multiple"
                                    selection={(this.props.values.state || "0") + "" !== "0" ? [] : this.state.fromSelection}
                                    onSelectionChange={(e) => {
                                        if ((this.props.values.state || "0") + "" !== "0") return;
                                        this.setState({poolSelection: [], fromSelection: e.value, toSelection: []});
                                    }}
                                />
                            </div>
                        </div>
                        {this.state.separated && <div className="col-md-6">
                            <div className="form-group">
                                <TargetList
                                    ref={(toList) => this.toList = toList}
                                    {...this.props}
                                    filter={[{field: "invoice.to", value: this.props.values.partner.partner_id}]}
                                    selectionMode="multiple"
                                    selection={(this.props.values.state || "0") + "" !== "0" ? [] : this.state.toSelection}
                                    onSelectionChange={(e) => {
                                        if ((this.props.values.state || "0") + "" !== "0") return;
                                        this.setState({poolSelection: [], fromSelection: [], toSelection: e.value});
                                    }}
                                />
                            </div>
                        </div>}
                    </div>
                </Fragment>}
                {
                    !!(this.props.values.moneytransfers || []).length &&
                    this.props.values.moneytransfers.map((moneytransfer, idx) => <div key={idx} className="row form-row">
                        <div className="col-md-10">
                            <div className="form-group">
                                <TextInput
                                    value={moneytransfer.amount}
                                    type="decimal"
                                    name="amount"
                                    label={moneytransfer.direction + "" === "1" ? "Bejövő utalás" : "Kimenő utalás"}
                                    disabled={true}
                                    formatter={CurrencyFormatter}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <DetailsButton
                                    component_type="TransactionPayment"
                                    component_id={moneytransfer.id}
                                />
                            </div>
                        </div>
                    </div>)
                }
            </form>
        );
    }
}

export default createForm(CompensationForm);
